"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const GlobalEvent_vue_1 = __importDefault(require("@/client/components/turmoil/GlobalEvent.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectGlobalEvent',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
            required: false,
            default: false,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: undefined,
        };
    },
    components: {
        GlobalEvent: GlobalEvent_vue_1.default,
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selected === undefined) {
                throw new Error('Select a global event');
            }
            this.onsave({ type: 'globalEvent', globalEventName: this.selected });
        },
    },
});
